<template>
    <div>
        <!-- <TopHeader /> -->
        <MainNavbar />
        <SidebarModal />
        <PageBanner pageTitle="About Us"  backgroundImage="https://plus.unsplash.com/premium_photo-1672116453187-3aa64afe04ad?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
        <AboutOurCompany />
        <PartnerLogo class="partner-logo-area pt-100 pb-75 bg-F4F8FC" />
        <HowWeWork />
        <WhyChooseUs />
        <OurClientTestimonial />
        <ContactUs />
        <FunFect class="pt-100" />
        <SubscribeNewsletter />
        <MainFooter />
    </div>
</template>

<script>
// import TopHeader from '../Layouts/TopHeader'

import MainNavbar from '../Layouts/MainNavbar'
import SidebarModal from '../Layouts/SidebarModal'
import PageBanner from '../Common/PageBanner'
import AboutOurCompany from '../AboutTwo/AboutOurCompany'
import PartnerLogo from '../Common/PartnerLogo'
import HowWeWork from '../AboutTwo/HowWeWork'
import WhyChooseUs from '../AboutTwo/WhyChooseUs'
import OurClientTestimonial from '../AboutTwo/OurClientTestimonial'
import ContactUs from '../AboutTwo/ContactUs'
import FunFect from '../Common/FunFect'
import SubscribeNewsletter from '../Common/SubscribeNewsletter'
import MainFooter from '../Layouts/MainFooter'

export default {
    name: 'AboutTwoPage',
    components: {
        // TopHeader,
        MainNavbar,
        SidebarModal,
        PageBanner,
        AboutOurCompany,
        PartnerLogo,
        HowWeWork,
        WhyChooseUs,
        OurClientTestimonial,
        ContactUs,
        FunFect,
        SubscribeNewsletter,
        MainFooter,
    }
}
</script>